export default {
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
  PAID: 'PAID',
  DELETED: 'DELETED',
};
